import { Alert, Button } from '@montugroup/design-system';

export const StocktakeError = ({ onRetry }: { onRetry: () => void }) => {
  return (
    <Alert
      severity="error"
      action={
        <Button color="inherit" size="small" onClick={onRetry}>
          Retry
        </Button>
      }
    >
      Unable to load stocktake. Please try again.
    </Alert>
  );
};
